/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ContextMenu,
  Element,
  ElementType,
  RelatedElementsConfig,
  TabElementProperty,
} from './data-contracts'
import { HttpClient, RequestParams } from './http-client'

export class CollectionClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags Collection
   * @summary Получить коллекцию типов элементов
   * @request GET:/objecttree/Collection/ElementTypeCollection
   * @secure
   */
  collectionGetElementTypeCollection = (params: RequestParams = {}) =>
    this.http.request<
      {
        None: Element
        WellsFolder: Element
        Field: Element
        Well: Element
        Inclinometry: Element
        WellBore: Element
        GISFolder: Element
        GIS: Element
        RIGISFolder: Element
        Lithology: Element
        VSP: Element
        MarkersFolder: Element
        Saturation: Element
        Marker: Element
        SpeedLawsFolder: Element
        SeismicFolder: Element
        SeismicSurveys: Element
        Survey3DFolder: Element
        ILine: Element
        XLine: Element
        ZSlice: Element
        Survey2DFolder: Element
        Profile: Element
        Interpretation: Element
        HorizonsFolder: Element
        Horizon: Element
        Interpretation2D: Element
        Interpretation3D: Element
        FaultsFolder: Element
        Fault: Element
        SticksFolder: Element
        Stick: Element
        PolygonsFolder: Element
        Polygon: Element
        MapsFolder: Element
        Map: Element
        PointsFolder: Element
        Points: Element
        GISList: Element
        RIGISList: Element
        VSPList: Element
        MarkerList: Element
        VelocityModelsFolder: Element
        VelocityModel: Element
        VirtualFolder: Element
      },
      any
    >({
      path: `/objecttree/Collection/ElementTypeCollection`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Collection
   * @summary Получить коллекцию свойств элементов вкладки
   * @request GET:/objecttree/Collection/TabElementTypeCollection
   * @secure
   */
  collectionGetTabElementTypeCollection = (params: RequestParams = {}) =>
    this.http.request<
      {
        Window3D: TabElementProperty
        Window2D: TabElementProperty
        Interpretation: TabElementProperty
        CorrelationScheme: TabElementProperty
        Table: TabElementProperty
        Chart: TabElementProperty
        Map: TabElementProperty
        CrossPlot: TabElementProperty
        GeoModule: TabElementProperty
      },
      any
    >({
      path: `/objecttree/Collection/TabElementTypeCollection`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Collection
   * @summary Получить коллекцию контекстных меню
   * @request GET:/objecttree/Collection/ContextMenuCollection
   * @secure
   */
  collectionGetContextMenuCollection = (params: RequestParams = {}) =>
    this.http.request<
      {
        None: ContextMenu[]
        WellsFolder: ContextMenu[]
        Field: ContextMenu[]
        Well: ContextMenu[]
        Inclinometry: ContextMenu[]
        WellBore: ContextMenu[]
        GISFolder: ContextMenu[]
        GIS: ContextMenu[]
        RIGISFolder: ContextMenu[]
        Lithology: ContextMenu[]
        VSP: ContextMenu[]
        MarkersFolder: ContextMenu[]
        Saturation: ContextMenu[]
        Marker: ContextMenu[]
        SpeedLawsFolder: ContextMenu[]
        SeismicFolder: ContextMenu[]
        SeismicSurveys: ContextMenu[]
        Survey3DFolder: ContextMenu[]
        ILine: ContextMenu[]
        XLine: ContextMenu[]
        ZSlice: ContextMenu[]
        Survey2DFolder: ContextMenu[]
        Profile: ContextMenu[]
        Interpretation: ContextMenu[]
        HorizonsFolder: ContextMenu[]
        Horizon: ContextMenu[]
        Interpretation2D: ContextMenu[]
        Interpretation3D: ContextMenu[]
        FaultsFolder: ContextMenu[]
        Fault: ContextMenu[]
        SticksFolder: ContextMenu[]
        Stick: ContextMenu[]
        PolygonsFolder: ContextMenu[]
        Polygon: ContextMenu[]
        MapsFolder: ContextMenu[]
        Map: ContextMenu[]
        PointsFolder: ContextMenu[]
        Points: ContextMenu[]
        GISList: ContextMenu[]
        RIGISList: ContextMenu[]
        VSPList: ContextMenu[]
        MarkerList: ContextMenu[]
        VelocityModelsFolder: ContextMenu[]
        VelocityModel: ContextMenu[]
        VirtualFolder: ContextMenu[]
      },
      any
    >({
      path: `/objecttree/Collection/ContextMenuCollection`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Collection
   * @summary Получить список допустимых типов элементов для ГСМ
   * @request GET:/objecttree/Collection/ValidVelocityElementTypes
   * @secure
   */
  collectionGetValidVelocityElementTypes = (params: RequestParams = {}) =>
    this.http.request<ElementType[], any>({
      path: `/objecttree/Collection/ValidVelocityElementTypes`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags Collection
   * @summary Получить конфигуратор зависимых элементов навигатора
   * @request GET:/objecttree/Collection/RelatedElementsConfig
   * @secure
   */
  collectionGetRelatedElementsConfig = (params: RequestParams = {}) =>
    this.http.request<RelatedElementsConfig[], any>({
      path: `/objecttree/Collection/RelatedElementsConfig`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    })
}
